module.exports = __webpack_public_path__ + "img/1e6da0fbe541ac9a1e0dae87ebc0baa6.png";